module.exports = __webpack_public_path__ + "static/media/dealership.e35ad6fa.png";